export default __webpack_public_path__ + "static/media/nero.861a22d7.jpg";